import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Books from "@/components/Books";
import Printables from "@/components/Printables";
import Characters from "@/components/Characters";
import Videos from "@/components/Videos";
import Pledge from "@/components/Pledge";
import Author from "@/components/Author";
import MemoirStrip from "@/components/MemoirStrip";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import VideoPage from "@/components/VideoPage";

const HomePage = () => (
  <main>
    <Hero />
    <Marquee />
    <Books />
    <Printables />
    <Characters />
    <Videos />
    <Pledge />
    <Author />
    <MemoirStrip />
    <Contact />
  </main>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="min-h-screen overflow-x-hidden bg-cream font-body text-ink antialiased">
        <div className="grain-overlay" aria-hidden="true" />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/videos/:slug" element={<VideoPage />} />
        </Routes>
        <Footer />
        <Toaster position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
